import { Folder } from '../folders.types';
import { FolderSelectionType } from './foldersDropdown.types';

// when a folder is added or removed from a decision
export function selectFolder({
  folders,
  folderKey,
  selected,
}: {
  folders: Array<FolderSelectionType>;
  folderKey: string;
  selected: boolean;
}) {
  const foldersCopy = [...folders];
  const folderToUpdate = foldersCopy.find(
    folder => folder.folderKey === folderKey,
  );
  if (folderToUpdate) {
    folderToUpdate.selected = !selected;
  }
  return { foldersUpdated: foldersCopy, folderUpdated: folderToUpdate };
}

// this object implements the method described here : https://stackoverflow.com/a/3976066
export class SearchFolders {
  folders: Array<Folder>;

  concat: string;

  constructor(folders: Array<Folder>) {
    this.folders = folders;
    this.concat = this.titleStringify(folders);
  }

  titleStringify = (folders: Array<Folder>): string =>
    folders.reduce(
      (acc: string, curr: Folder, index: number) =>
        `${acc}"${index}_${curr.title}"`,
      '',
    );

  filterFolders = (indexes: Array<string>): Array<Folder> =>
    indexes.map((index: string) => this.folders[+index]);

  matchTitle = (search: string): Array<Folder> => {
    const pattern = `"(\\d+)_([^"]*${search}[^"]*)"`;
    const regex = new RegExp(pattern, 'gmi');

    let indexes: [] | Array<string> = [];
    let r;

    /* eslint-disable no-cond-assign */
    while ((r = regex.exec(this.concat)) !== null) {
      indexes = [...indexes, r[1]];
      /* eslint-enable no-cond-assign */
    }

    const filteredFolders: Array<Folder> = this.filterFolders(indexes);

    return filteredFolders;
  };
}
